// src/types.ts

export type ApplicationItemStatus = "created" | "in-progress" | "completed";

export type StepType =
  | "basic"
  | "housing"
  | "identity"
  | "financial"
  | "income"
  | "documents";

export interface BasicData {
  dob?: string;
}

export interface ApplicationHousingEntry {
  address: string;
  moveInDate: string;
  moveOutDate?: string;
  currentResidence: boolean;
  manager: string;
  phone: string;
  email: string;
}

export interface ApplicationIncomeEntry {
  type: ApplicationIncomeType;
  description: string;
  company: string;
  address: string;
  phone: string;
  jobTitle: string;
  monthlyNetIncome: string;
  startDate: string;
  endDate?: string | null;
  current: boolean;
  payFrequency: PayFrequency;
}

export interface ApplicationDocumentEntry {
  id: number;
  createdAt: string;
  type: string;
  fileName: string;
  url: string;
}

export interface ApplicationIdentityDetails {
  firstName: string;
  lastName: string;
  dob: string;
}

export interface ApplicationBankDetails {
  institution: string;
  logoUrl: string;
  accountNumber: string;
}

interface ApplicationBaseItem {
  id: string;
  title: string;
  description: string;
  status: ApplicationItemStatus;
}

export interface ApplicationBasicItem extends ApplicationBaseItem {
  type: "basic";
  data: BasicData;
}

export interface ApplicationHousingItem extends ApplicationBaseItem {
  type: "housing";
  data: ApplicationHousingEntry[];
}

export interface ApplicationIdentityItem extends ApplicationBaseItem {
  type: "identity";
  data: ApplicationIdentityDetails;
}

export interface ApplicationBankItem extends ApplicationBaseItem {
  type: "financial";
  data: ApplicationBankDetails;
}

export interface ApplicationIncomeItem extends ApplicationBaseItem {
  type: "income";
  data: ApplicationIncomeEntry[];
}

export interface ApplicationEmploymentItem extends ApplicationBaseItem {
  type: "income";
  data?: undefined;
}

export interface ApplicationDocumentsItem extends ApplicationBaseItem {
  type: "documents";
  data: ApplicationDocumentEntry[];
}

// unified union
export type ApplicationItem =
  | ApplicationBasicItem
  | ApplicationHousingItem
  | ApplicationIdentityItem
  | ApplicationBankItem
  | ApplicationIncomeItem
  | ApplicationEmploymentItem
  | ApplicationDocumentsItem;

export interface Application {
  id: string;
  items: ApplicationItem[];
}

export enum ApplicationIncomeType {
  EMPLOYMENT = "employment",
  FREELANCE = "freelance",
  BENEFITS = "benefits",
}

export enum PayFrequency {
  DAILY = "daily",
  WEEKLY = "weekly",
  BIWEEKLY = "bi-weekly",
  MONTHLY = "monthly",
  VARIES = "varies",
}

export enum AnimalType {
  Pet = "pet",
  ServiceAnimal = "service-animal",
  Both = "both",
  Neither = "neither",
}
